import actionTypes from './types';

const snackBar = (
  state = {
    show: false,
    variant: 'error',
    message: '',
  },
  action: { type: string; payload: any },
) => {
  switch (action.type) {
    case actionTypes.SHOW_SNACKBAR:
      return {
        ...state,
        show: true,
        variant: action.payload.variant,
        message: action.payload.message,
      };

    case actionTypes.HIDE_SNACKBAR:
      return {
        ...state,
        show: false,
        variant: 'error',
        message: '',
      };

    default:
      return state;
  }
};

export default snackBar;
